// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1KIEB","productName":"Table_productName__1Oyi2"};